module.exports = __webpack_public_path__ + "static/media/products-6.d975b180.jpg";